// extracted by mini-css-extract-plugin
module.exports = {"owner":"Ratings_owner__sx3zF"};